<div class="row-header">
  <div>
    <span>{{header | translate}}</span>
    <mat-icon
      class="text-xs gray-text pointer"
      [matTooltip]="description | translate">help_outline
    </mat-icon>
  </div>
  <ng-template
    [ngxPermissionsOnly]="permission"
    [ngxPermissionsOnlyThen]="thenBlock"
    [ngxPermissionsOnlyElse]="elseBlock">
  </ng-template>
  <ng-template #elseBlock>
    <div>
      <button mat-raised-button
              color="info-full"
              (click)="upgradeAccount()">
        {{'PHONE.MESSAGES.UPGRADE_ACCOUNT' | translate}}
      </button>
    </div>
  </ng-template>
  <ng-template #thenBlock>
    <div class="tools">
      <mat-icon
        class="grey-text pointer"
        [class.active]="opened"
        (click)="changeOpened.next(!opened)">keyboard_arrow_down
      </mat-icon>
      <ui-switch
        *ngIf="canBeEnabled"
        class="custom"
        [checked]="isActive"
        [disabled]="!bucketFileName"
        (change)="changeActiveState($event)"
      ></ui-switch>
    </div>
  </ng-template>
</div>

<div
  class="row-body"
  *ngIf="opened"
>
  <cc-audio-message-upload
    [bucketFileName]="bucketFileName"
    [fileUrl]="url"
    [fileName]="fileName"
    [fileType]="type"
    (remove)="remove()"
    (update)="refresh()"
  ></cc-audio-message-upload>
</div>
